export default __webpack_public_path__ + "static/mobile-room-layout-5a44b24ecbdd682f557a578422aaec00.jpg";